export default __webpack_public_path__ + "static/port-3-28cb0bef39dda5e3ab9d547a2fae06d9.jpeg";